import React, { useEffect, useState } from 'react';
import { Dialog } from "evergreen-ui";
import { Input, message } from "antd";
import { invalidateDemoData, useListVals } from "../../Firebase/databaseHooks";
import Firebase from "../../Firebase/Firebase";
import {
    read, utils
} from "xlsx";
import FireFetch from "../../Firebase/FireFetch";
import { getDatabase, ref, update } from "firebase/database";
import { useAuth } from "../../AuthContext/AuthContext";



const db = getDatabase(Firebase);
const InitiativeUpload = (props) => {
    const { canAccessModule } = useAuth();
    const canCreateAdminConfig = canAccessModule("ADMIN_CONFIGS", "create");

    const [showModal, setShowModal] = useState(props.showModal);
    const [file, setFile] = useState(null);
    const [languages] = useListVals(ref(db, "talmidsdb/languages"));
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setShowModal(props.showModal);
    }, [props]);

    const handleFileUpload = (e) => {
        setFile(e.target.files[0]);
    }
    const arrayToObject = (array) =>
        array.reduce((obj, item) => {
            obj[item[`${props.id}ID`]] = item
            return obj
        }, {});


    function readFile() {
        if (!canCreateAdminConfig) {
            message.error("You do not have permission to upload initiatives.");
            setLoading(false);
            return;
        }
        if (!file) {
            message.error("Please select a file to upload.");
            setLoading(false);
            return;
        }

        const reader = new FileReader();
        reader.onload = (evt) => {
            // evt = on_file_select event
            /* Parse data */
            const bstr = evt.target.result;
            const wb = read(bstr, { type: "binary" });
            /* Get first worksheet */
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            /* Convert array of arrays */
            const data = utils.sheet_to_csv(ws, { header: 1 });
            /* Update state */

            const dataArray = FireFetch.convertToJson(data);
            var tempArray = [];
            dataArray.map((item) => {
                var newObject = {};
                Object.keys(item).forEach((key) => {
                    var newKey = key.split(" ").length > 1 ? key.split(" ")[0].toLowerCase() + "" + key.split(" ")[1] :
                        key.split(" ")[0].toLowerCase();
                    newObject[newKey.trim()] = item[key.trim()] ? item[key.trim()] : "";
                });
                tempArray.push(newObject);
            });
            console.log(tempArray);
            tempArray = tempArray.filter(x => x.initiative !== "");
            tempArray.map((item) => {
                item[`${props.id}ID`] = Array(12).fill("ABCDEFGHIJKLMNOPQRSTUVWXYZ123456789abcdefghijklmnopqrstuvwxyz")
                    .map(function (x) { return x[Math.floor(Math.random() * x.length)] }).join('');
                const rawLanguage = typeof item.language === "string" ? item.language.trim() : "";
                const matchedLanguage = languages.find((x) =>
                    x.language === rawLanguage || x.languageName === rawLanguage
                );
                item.language = matchedLanguage?.languageID || matchedLanguage?.id;
                item.initiativeSector = item.sector;

                delete item.action;
                delete item.sector;
                delete item.key;
            })

            const arrayObjects = arrayToObject(tempArray);
            console.log(arrayObjects);

            update(ref(db, "talmidsdb/initiatives"), arrayObjects).then(() => {
                invalidateDemoData("talmidsdb/initiatives");
                message.success("Initiatives uploaded successfully");
                setShowModal(false);
                setLoading(false);
            }).catch((error) => {
                message.error(error);
                setLoading(false);
            });


        };
        reader.readAsBinaryString(file);
    }



    return (
        <>
            <Dialog
                isShown={showModal}
                title="Upload Task"
                onCloseComplete={() => { setShowModal(false) }}
                onConfirm={() => {
                    setLoading(true);
                    readFile();
                }}
                isConfirmDisabled={!canCreateAdminConfig || !file}
                isConfirmLoading={loading}
            >
                <div>
                    <Input
                        type="file"
                        style={{ width: "100%" }}
                        accept=".xlsx, .xls, .csv"
                        placeholder="select excel file"
                        size="large"
                        className="mt-2 w-100"
                        disabled={!canCreateAdminConfig}
                        onChange={handleFileUpload} />
                </div>

            </Dialog>

        </>
    )
}

export default InitiativeUpload;
